export const gauge = {
    outerRadius: .8,
    innerRadius: .6,
    padAngle: 1.146,
    segment: {
        style: {
            fillOpacity: 1
        }
    },
    tickMask: {
        visible: !1,
        angle: 3,
        offsetAngle: 0,
        forceAlign: !0
    }
};
//# sourceMappingURL=gauge.js.map
